import React from 'react';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { useAuthStore } from '../../store/authStore';
import { useNavigate } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-container d-flex flex-column min-vh-100">
      <Navbar expand="lg" className="modern-navbar mb-4 sticky-top" style={{
        backgroundColor: 'var(--bg-dark)',
        borderBottom: '1px solid var(--border-light)',
        boxShadow: 'var(--shadow-md)',
        zIndex: 1030
      }}>
        <Container>
          <Navbar.Brand href="/" className="text-white fw-bold fs-4">
            <i className="bi bi-calendar-check me-2"></i>
            SIIS Admin Panel
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/appointments" className="text-white-50 px-3 py-2 rounded me-2 nav-link-modern">
                <i className="bi bi-calendar-event me-2"></i>Appointments
              </Nav.Link>
              <Nav.Link href="/pricing" className="text-white-50 px-3 py-2 rounded me-2 nav-link-modern">
                <i className="bi bi-currency-dollar me-2"></i>Pricing
              </Nav.Link>
              <Nav.Link href="/dates" className="text-white-50 px-3 py-2 rounded me-2 nav-link-modern">
                <i className="bi bi-calendar3 me-2"></i>Dates & Slots
              </Nav.Link>
              <Nav.Link href="/custom-payments" className="text-white-50 px-3 py-2 rounded me-2 nav-link-modern">
                <i className="bi bi-credit-card me-2"></i>Custom Payments
              </Nav.Link>
            </Nav>
            <Nav>
              <Navbar.Text className="me-3 text-white-50">
                <i className="bi bi-person-circle me-2"></i>
                Welcome, {user?.name || user?.email}
              </Navbar.Text>
              <Button 
                variant="outline-light" 
                size="sm" 
                onClick={handleLogout}
                className="logout-btn"
                style={{
                  borderColor: 'var(--danger-color)',
                  color: 'var(--danger-color)',
                  borderRadius: 'var(--radius-md)',
                  fontWeight: '500'
                }}
              >
                <i className="bi bi-box-arrow-right me-2"></i>Logout
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      
      <Container fluid className="px-4">
        {children}
      </Container>
      
      {/* Footer */}
      <footer className="mt-auto py-2" style={{
        backgroundColor: 'white',
        borderTop: '1px solid #e9ecef',
        marginTop: 'auto'
      }}>
        <Container>
          <div className="text-center text-muted">
            <small>© 2025 Pithad Solutions. All rights reserved.</small>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default Layout;
